import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { SdObjType } from '../Enums/SdObjType.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputEingangslieferschein<T extends EMode = EMode.entity> {
  /** Alias: reCode */
  reCode?: number;
  /** Alias: eingangslieferscheinArt */
  eingangslieferscheinArt?: any;
  /** Alias: lieferscheinNummer */
  lieferscheinNummer?: string;
  /** Alias: lieferDatum */
  lieferDatum?: string;
  /** Alias: mietdauer */
  mietdauer?: number;
  /** Alias: mietfaktor */
  mietfaktor?: number;
  /** Alias: code */
  code?: number;
  /** Alias: nummer */
  nummer?: number;
  /** Alias: hauptadresseApCode */
  hauptadresseApCode?: number;
  /** Alias: hauptadresseCompanyType */
  hauptadresseCompanyType?: SdObjType;
  /** Alias: hauptadresseCompanyCode */
  hauptadresseCompanyCode?: number;
  /** Alias: hauptadresseText */
  hauptadresseText?: string;
  /** Alias: hauptadresseAnPostfach */
  hauptadresseAnPostfach?: boolean;
  /** Alias: hauptAdresseAbteilungCode */
  hauptAdresseAbteilungCode?: number;
  /** Alias: nebenadresse1AnPostfach */
  nebenadresse1AnPostfach?: boolean;
  /** Alias: nebenadresse2AnPostfach */
  nebenadresse2AnPostfach?: boolean;
  /** Alias: nebenadresse3AnPostfach */
  nebenadresse3AnPostfach?: boolean;
  /** Alias: benutzerCode */
  benutzerCode?: number;
  /** Alias: benutzerCode2 */
  benutzerCode2?: number;
  /** Alias: datum */
  datum?: string;
  /** Alias: eingefroren */
  eingefroren?: boolean;
  /** Alias: ihrZeichen */
  ihrZeichen?: string;
  /** Alias: unserZeichen */
  unserZeichen?: string;
  /** Alias: kopftext */
  kopftext?: string;
  /** Alias: schlusstext */
  schlusstext?: string;
  /** Alias: rtfKopftext */
  rtfKopftext?: string;
  /** Alias: rtfSchlusstext */
  rtfSchlusstext?: string;
  /** Alias: kostenstelle */
  kostenstelle?: number;
  /** Alias: kurs */
  kurs?: number;
  /** Alias: kursDatum */
  kursDatum?: string;
  /** Alias: notiz */
  notiz?: string;
  /** Alias: projektCode */
  projektCode?: number;
  /** Alias: status1 */
  status1?: number;
  /** Alias: status2 */
  status2?: number;
  /** Alias: status3 */
  status3?: number;
  /** Alias: status4 */
  status4?: number;
  /** Alias: status5 */
  status5?: number;
  /** Alias: waehrungCode */
  waehrungCode?: number;
  /** Alias: feld1 */
  feld1?: string;
  /** Alias: feld2 */
  feld2?: string;
  /** Alias: feld3 */
  feld3?: string;
  /** Alias: feld4 */
  feld4?: string;
  /** Alias: feld5 */
  feld5?: string;
  /** Alias: feld6 */
  feld6?: string;
  /** Alias: feld7 */
  feld7?: string;
  /** Alias: projektVorgangCode */
  projektVorgangCode?: number;
  /** Alias: leistungsort */
  leistungsort?: string;
  /** Alias: bruttowert */
  bruttowert?: number;
  /** Alias: wartungsCode */
  wartungsCode?: number;
  /** Alias: abgeschlossen */
  abgeschlossen?: boolean;
  /** Alias: mobileBearbeitung */
  mobileBearbeitung?: any;
  /** Alias: lieferterminAbgehend */
  lieferterminAbgehend?: string;
  /** Alias: leistungsbeginn */
  leistungsbeginn?: string;
  /** Alias: leistungsende */
  leistungsende?: string;
  /** Alias: createdByLoginId */
  createdByLoginId?: string;
  /** Alias: webShopOrderDefinitionData */
  webShopOrderDefinitionData?: string;
  /** Alias: niederlassungsCode */
  niederlassungsCode?: number;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];
  /** Alias: createdByUserCode */
  createdByUserCode?: number;

  __typename?: string;
}

const fields: FieldDefinitions<InputEingangslieferschein> = {
  reCode: {
    alias: 'reCode',
  },
  eingangslieferscheinArt: {
    alias: 'eingangslieferscheinArt',
  },
  lieferscheinNummer: {
    alias: 'lieferscheinNummer',
  },
  lieferDatum: {
    alias: 'lieferDatum',
  },
  mietdauer: {
    alias: 'mietdauer',
  },
  mietfaktor: {
    alias: 'mietfaktor',
  },
  code: {
    alias: 'code',
  },
  nummer: {
    alias: 'nummer',
  },
  hauptadresseApCode: {
    alias: 'hauptadresseApCode',
  },
  hauptadresseCompanyType: {
    alias: 'hauptadresseCompanyType',
  },
  hauptadresseCompanyCode: {
    alias: 'hauptadresseCompanyCode',
  },
  hauptadresseText: {
    alias: 'hauptadresseText',
  },
  hauptadresseAnPostfach: {
    alias: 'hauptadresseAnPostfach',
  },
  hauptAdresseAbteilungCode: {
    alias: 'hauptAdresseAbteilungCode',
  },
  nebenadresse1AnPostfach: {
    alias: 'nebenadresse1AnPostfach',
  },
  nebenadresse2AnPostfach: {
    alias: 'nebenadresse2AnPostfach',
  },
  nebenadresse3AnPostfach: {
    alias: 'nebenadresse3AnPostfach',
  },
  benutzerCode: {
    alias: 'benutzerCode',
  },
  benutzerCode2: {
    alias: 'benutzerCode2',
  },
  datum: {
    alias: 'datum',
  },
  eingefroren: {
    alias: 'eingefroren',
  },
  ihrZeichen: {
    alias: 'ihrZeichen',
  },
  unserZeichen: {
    alias: 'unserZeichen',
  },
  kopftext: {
    alias: 'kopftext',
  },
  schlusstext: {
    alias: 'schlusstext',
  },
  rtfKopftext: {
    alias: 'rtfKopftext',
  },
  rtfSchlusstext: {
    alias: 'rtfSchlusstext',
  },
  kostenstelle: {
    alias: 'kostenstelle',
  },
  kurs: {
    alias: 'kurs',
  },
  kursDatum: {
    alias: 'kursDatum',
  },
  notiz: {
    alias: 'notiz',
  },
  projektCode: {
    alias: 'projektCode',
  },
  status1: {
    alias: 'status1',
  },
  status2: {
    alias: 'status2',
  },
  status3: {
    alias: 'status3',
  },
  status4: {
    alias: 'status4',
  },
  status5: {
    alias: 'status5',
  },
  waehrungCode: {
    alias: 'waehrungCode',
  },
  feld1: {
    alias: 'feld1',
  },
  feld2: {
    alias: 'feld2',
  },
  feld3: {
    alias: 'feld3',
  },
  feld4: {
    alias: 'feld4',
  },
  feld5: {
    alias: 'feld5',
  },
  feld6: {
    alias: 'feld6',
  },
  feld7: {
    alias: 'feld7',
  },
  projektVorgangCode: {
    alias: 'projektVorgangCode',
  },
  leistungsort: {
    alias: 'leistungsort',
  },
  bruttowert: {
    alias: 'bruttowert',
  },
  wartungsCode: {
    alias: 'wartungsCode',
  },
  abgeschlossen: {
    alias: 'abgeschlossen',
  },
  mobileBearbeitung: {
    alias: 'mobileBearbeitung',
  },
  lieferterminAbgehend: {
    alias: 'lieferterminAbgehend',
  },
  leistungsbeginn: {
    alias: 'leistungsbeginn',
  },
  leistungsende: {
    alias: 'leistungsende',
  },
  createdByLoginId: {
    alias: 'createdByLoginId',
  },
  webShopOrderDefinitionData: {
    alias: 'webShopOrderDefinitionData',
  },
  niederlassungsCode: {
    alias: 'niederlassungsCode',
  },
  updateTime: {
    alias: 'updateTime',
  },
  insertTime: {
    alias: 'insertTime',
  },
  customFields: {
    alias: 'customFields',
  },
  createdByUserCode: {
    alias: 'createdByUserCode',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputEingangslieferscheinEntityDefinition: EntitiyDefinition<InputEingangslieferschein> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputEingangslieferschein',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
